import type { RootState } from '~/reducers/index';
import type { PLPPhotoPreviewState } from '~/cards/reducers/plpPhotoPreview';

export const getPLPPhotoPreviewState = (state: RootState): PLPPhotoPreviewState | null =>
  state?.cards?.plpPhotoPreview || null;
